import { getPublicAdminGateStatus, verifyAdminGateAccessCode } from '../../../api/system/systemStatus';

export async function fetchAdminGateStatus() {
  return getPublicAdminGateStatus();
}

export async function verifyAdminAccessCode(code) {
  return verifyAdminGateAccessCode(code);
}
